import { Link } from "react-router-dom";
export default function HeroSection() {
  return (
    <section id="herosection" className="pt-24 lg:pt-32 pb-16 lg:pb-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Meet Vollet.<br />
              <span className="text-[#4C6FFF]">Your everyday crypto wallet.</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-xl mx-auto lg:mx-0">
              Send, receive and manage your crypto in a few taps – with security you can trust.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-4">
              <Link to="/comingsoon"
                className="bg-[#4C6FFF] hover:bg-[#3B5EEE] text-white px-8 py-4 rounded-full font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-line text-lg"></i>
                </div>
                Download for Android
              </Link>
              <Link to="/comingsoon"
                className="bg-white hover:bg-gray-50 text-gray-900 px-8 py-4 rounded-full font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-2 border border-gray-200 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-line text-lg"></i>
                </div>
                Download for iOS
              </Link>
            </div>
            <p className="text-sm text-gray-500">More platforms coming soon.</p>
          </div>

          {/* Phone Mockup */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-72 sm:w-80 lg:w-96 bg-gray-900 rounded-[3rem] p-3 shadow-2xl">
                <div className="bg-white rounded-[2.5rem] overflow-hidden">
                  {/* Status Bar */}
                  <div className="bg-gray-100 px-6 py-3 flex justify-between items-center">
                    <span className="text-xs font-medium text-gray-600">9:41</span>
                    <div className="flex items-center gap-1">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-signal-wifi-3-line text-xs text-gray-600"></i>
                      </div>
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-battery-2-charge-line text-xs text-gray-600"></i>
                      </div>
                    </div>
                  </div>

                  {/* App Content */}
                  <div className="p-6">
                    {/* Balance */}
                    <div className="text-center mb-6 ">
                      <p className="text-sm text-gray-500 mb-1">Total Balance</p>
                      <h2 className="text-3xl font-bold text-gray-900">$12,458.32</h2>
                      <p className="ttlp">Account 1(Imported) <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.1905 6L10.0952 12.0952L4 6" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                      </svg>
                      </p>
                      <p className="copy_n"><span>0xcaB7D5E...dD5...</span> <a href="" >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0477 9.52414V4.1908C11.0477 3.34922 10.3655 2.66699 9.52389 2.66699H4.19056C3.34898 2.66699 2.66675 3.34922 2.66675 4.1908V9.52414C2.66675 10.3657 3.34898 11.0479 4.19056 11.0479H9.52389C10.3655 11.0479 11.0477 10.3657 11.0477 9.52414Z" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.95239 11.0484V11.8103C4.95239 12.6518 5.63463 13.3341 6.4762 13.3341H11.8095C12.6511 13.3341 13.3333 12.6518 13.3333 11.8103V6.47693C13.3333 5.63536 12.6511 4.95312 11.8095 4.95312H11.0476" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a></p>
                    </div>

                    {/* Action Buttons */}

                    <div className="button_gp">

                      <button className="btn_s"><svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0866 0.373698L5.60266 11.5045M5.60266 11.5045L0.817188 4.71825M5.60266 11.5045L13.9208 9.65741" stroke="#E84343" stroke-width="2" />
                      </svg> Send
                      </button>
                      <span><svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none">
                        <path d="M1 6.20836V5C1 2.79086 2.79086 1 5 1H22C24.2091 1 26 2.79086 26 5V6.20836" stroke="white" stroke-width="2" />
                        <path d="M1 15.5836V16.792C1 19.0011 2.79086 20.792 5 20.792H22C24.2091 20.792 26 19.0011 26 16.792V15.5836" stroke="white" stroke-width="2" />
                        <path d="M1 11.417H26" stroke="white" stroke-width="2" />
                      </svg></span>
                      <button className="btn_s"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                        <path d="M4.05088 12.2513L8.53479 1.12051M8.53479 1.12051L13.3203 7.90675M8.53479 1.12051L0.216682 2.96759" stroke="#24B664" stroke-width="2" />
                      </svg>Receive</button>
                    </div>



                    <p className="sct">Scan to connect</p>


                    {/* Token List */}
                    <div className="space-y-3">
                      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">₿</span>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">Bitcoin</p>
                            <p className="text-xs text-gray-500">0.142 BTC</p>
                          </div>
                        </div>
                        <p className="text-sm font-medium text-gray-900">$8,234.12</p>
                      </div>
                      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">Ξ</span>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">Ethereum</p>
                            <p className="text-xs text-gray-500">1.85 ETH</p>
                          </div>
                        </div>
                        <p className="text-sm font-medium text-gray-900">$4,224.20</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#4C6FFF]/10 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#00D0A3]/10 rounded-full blur-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
